import { useCallback, useEffect } from 'react';
import { LeadersList } from '@features/landing/grandprix/ui/components/LeadersList/index';
import { useGSAP } from '@features/landing/shared/providers/GsapProvider';
import {
  LeaderboardClock,
  LeaderboardTillAge,
  LeaderboardType,
} from '@features/landing/grandprix/typings';
import { useInfiniteLeaderboardQuery } from '@features/shared/api/user';
import {
  getLeaderboardId,
  LeaderboardParams,
} from '@features/landing/grandprix/utils/leaderboard';
import { Loader } from '@ui/components/Loader';
import { AllParticipantsButton } from '@features/landing/shared/ui/components/AllParticipantsButton';
import { useLeaderboard } from '@features/landing/grandprix/providers/LeaderboardProvider';

type Props = {
  tillAge: LeaderboardTillAge;
  clock: LeaderboardClock;
  leaderboardType: LeaderboardType;
  limit: number;
  showTypeTitle?: boolean;
  onActionClick: (params: LeaderboardParams) => void;
  className?: string;
  preset?: 'landing' | 'club';
};

const TYPE_TITLES: Record<LeaderboardType, string> = {
  open: 'Open',
  girls: 'Девушки',
};

export function LeadersListWidget({
  tillAge,
  clock,
  leaderboardType,
  limit,
  showTypeTitle,
  onActionClick,
  className,
  preset = 'landing',
}: Props) {
  const { ScrollTrigger } = useGSAP();

  const { data, isLoading } = useInfiniteLeaderboardQuery(
    getLeaderboardId({
      clock,
      leaderboardType,
      tillAge,
    }),
    {
      limit,
    },
  );

  useEffect(() => {
    ScrollTrigger?.refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const leaderboard = useLeaderboard();

  const onActionClickHandler = useCallback(() => {
    leaderboard.setTillAge(tillAge);
    leaderboard.setClock(clock);
    leaderboard.setLeaderboardType(leaderboardType);
    onActionClick({
      tillAge,
      clock,
      leaderboardType,
    });
  }, [leaderboard, tillAge, leaderboardType, clock, onActionClick]);

  if (isLoading) {
    return <Loader centered />;
  }

  return (
    <LeadersList
      title={showTypeTitle ? TYPE_TITLES[leaderboardType] : undefined}
      className={className}
      preset={preset}
      leaders={data || []}
      action={
        <AllParticipantsButton
          onClick={onActionClickHandler}
          leaderboardType={leaderboardType}
          preset={preset}
        />
      }
    />
  );
}
